import css from './GSEventBox.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { IGoodServiceTicketData } from 'meta/pages/goodsandservices'
import { Dates } from 'utils/dates'

interface Props {
  data: IGoodServiceTicketData
}

const GSEventBox: React.FC<Props> = (props) => {
  const { data } = props

  const { t } = useTranslation()

  const eventDate = Dates.format(new Date(data.event.datetime_tz), t('dates:common:dayMonthYear'))

  return (
    <div className={css.eventBox}>
      <div className={css.title}>{data.event.name}</div>
      <div className={css.description}>{`${data.locationName} del ${eventDate}`}</div>
    </div>
  )
}

export default GSEventBox
